const faq = [
  {
    id: 1,
    category: "General & Getting Started",
    question: "What is SoloChat?",
    answer:
      "SoloChat is an all-in-one social messaging platform that combines secure messaging, high-quality calls, public rooms for community discussion, a short-video feed (Minutes), and social discovery features through our interactive map.",
  },
  {
    id: 2,
    category: "General & Getting Started",
    question: "How do I sign up?",
    answer:
      "You can sign up using your phone number. We also support Google Sign-In for a faster onboarding experience. After registering, you'll be prompted to set up your profile with a name and optional profile picture.",
  },
  {
    id: 3,
    category: "General & Getting Started",
    question: "Is SoloChat free to use?",
    answer:
      "Yes! Core features like messaging, calling, and joining most rooms are free. We offer a Premium subscription and a coin-based economy for advanced features, special customization, and marketplace transactions.",
  },
  {
    id: 4,
    category: "Messaging & Calls",
    question: "Can I edit or delete messages?",
    answer:
      "Yes. You can edit messages within a certain timeframe after sending. You can also delete messages for yourself or for everyone in the chat.",
  },
  {
    id: 5,
    category: "Messaging & Calls",
    question: "What media types can I share?",
    answer:
      "You can share images, videos, multi-media albums, documents (PDF, DOC, XLS, ZIP, etc.), voice notes, and even your current or a selected location.",
  },
  {
    id: 6,
    category: "Messaging & Calls",
    question: "How do I use Polls?",
    answer:
      "In any chat or group, tap the \"+\" icon and select \"Poll.\" You can add a question and multiple options for your contacts to vote on.",
  },
  {
    id: 7,
    category: "Messaging & Calls",
    question: "Can I create my own stickers?",
    answer:
      "Absolutely! SoloChat features a unique \"Sticker Creator\" where you can turn your own videos or images into custom stickers and memojis to share with friends.",
  },
  {
    id: 8,
    category: "Messaging & Calls",
    question: "How do I customize my chat background?",
    answer:
      "You can set a custom wallpaper for all your chats or individual ones. Visit the Sticker Store to find exclusive artist-designed wallpapers or use your own images from the Inventory.",
  },
  {
    id: 9,
    category: "Messaging & Calls",
    question: "Does SoloChat support message translation?",
    answer:
      "Yes! If you receive a message in a different language, you can tap and hold it to bring up the translation options. We support a wide range of languages to help you communicate globally.",
  },
  {
    id: 10,
    category: "Messaging & Calls",
    question: "Does SoloChat support video calls?",
    answer:
      "Yes, we support both one-on-one voice and video calls, as well as group calls within Rooms.",
  },
  {
    id: 11,
    category: "Groups & Rooms",
    question: "What is the difference between a Group and a Room?",
    answer:
      "Groups are typically private and intended for your direct contacts. Rooms are community-focused spaces. They can be public or private and are designed for larger discussions, often featuring persistent voice/video sessions.",
  },
  {
    id: 12,
    category: "Groups & Rooms",
    question: "How do I find public Rooms?",
    answer:
      "Navigate to the \"Explore Rooms\" section or use the Discovery Map to find trending and recommended rooms near you or globally.",
  },
  {
    id: 13,
    category: "Groups & Rooms",
    question: "Can I transfer ownership of a Group or Room?",
    answer:
      "Yes, owners can transfer their role to another participant via the Group/Room Settings.",
  },
  {
    id: 14,
    category: "Minutes (Short Videos)",
    question: "What are \"Minutes\"?",
    answer:
      "\"Minutes\" is our short-form video feature, similar to TikTok. You can watch trending videos, follow creators, and share your own moments with the community.",
  },
  {
    id: 15,
    category: "Minutes (Short Videos)",
    question: "How do I create a Minute video?",
    answer:
      "Tap the \"+\" icon on the Minutes tab. You can record a new video or upload one from your gallery. Our built-in editor allows you to trim your video and add background music from our library (powered by Spotify and Deezer).",
  },
  {
    id: 16,
    category: "Minutes (Short Videos)",
    question: "Can I share Minutes privately?",
    answer:
      "Yes, you can send Minute videos directly to your friends in chats or repost them to your own feed.",
  },
  {
    id: 17,
    category: "Discovery & Maps",
    question: "What is the Discovery Map?",
    answer:
      "The Discovery Map allows you to find other SoloChat users and public rooms based on location. It's a great way to meet new people and find local communities.",
  },
  {
    id: 18,
    category: "Discovery & Maps",
    question: "How do I adjust my location privacy?",
    answer:
      "You can choose to hide your location from the map or adjust who can see you in the Privacy Settings. Premium users can also \"teleport\" to different locations to discover people around the world.",
  },
  {
    id: 19,
    category: "Privacy, Security & Safety",
    question: "Is my data secure?",
    answer:
      "We prioritize your privacy. Messaging features include options to restrict messages, hide chats, and block unwanted users.",
  },
  {
    id: 20,
    category: "Privacy, Security & Safety",
    question: "How do I report inappropriate content?",
    answer:
      "If you encounter content that violates our community guidelines, you can report it by tapping the \"Report\" option on the message, video, or user profile. Our moderation team reviews all reports.",
  },
  {
    id: 21,
    category: "Privacy, Security & Safety",
    question: "What are \"Interests\" used for?",
    answer:
      "When you set up your profile, you can select your interests. We use these to recommend relevant Rooms, Minute videos, and people you might like to connect with on the map.",
  },
  {
    id: 22,
    category: "Privacy, Security & Safety",
    question: "How do I block someone?",
    answer:
      "Go to the user's profile and select \"Block.\" You can manage your list of blocked users in Settings > Privacy > Blocked Users.",
  },
  {
    id: 23,
    category: "Privacy, Security & Safety",
    question: "What are \"Restricted Messages\"?",
    answer:
      "You can restrict specific messages so they can only be viewed by certain participants in a group, adding an extra layer of privacy for sensitive information.",
  },
  {
    id: 24,
    category: "Economy: Coins, Marketplace & Wallet",
    question: "What are SoloChat Coins?",
    answer:
      "Coins are our virtual currency. You can use them to purchase stickers, wallpapers, or items in the Marketplace. You can also earn coins through referrals or by watching rewarded ads.",
  },
  {
    id: 25,
    category: "Economy: Coins, Marketplace & Wallet",
    question: "What is the Marketplace?",
    answer:
      "The Marketplace is where users can discover and trade items or services. You can use your coins to make purchases directly within the app.",
  },
  {
    id: 26,
    category: "Economy: Coins, Marketplace & Wallet",
    question: "How do I get more coins?",
    answer:
      "You can purchase coin packages in the Wallet section, earn them by referring friends (\"Refer & Earn\"), or even sell your extra coins back to the community in some regions.",
  },
  {
    id: 27,
    category: "Economy: Coins, Marketplace & Wallet",
    question: "Can I promote my own content?",
    answer:
      "Yes! Creators and businesses can use \"Sponsored Videos\" to promote their Minutes to a wider audience. This can be managed through the Wallet or Video Settings.",
  },
  {
    id: 28,
    category: "Premium & Subscriptions",
    question: "What are the benefits of SoloChat Premium?",
    answer:
      "Premium members enjoy an ad-free experience, global search on the Discovery Map, exclusive stickers and wallpapers, higher limits for group participants, and advanced AI features.",
  },
  {
    id: 29,
    category: "Premium & Subscriptions",
    question: "How do I subscribe?",
    answer:
      "Go to the Wallet or Settings and tap on \"Subscription.\" We offer various plans to suit your needs.",
  },
  {
    id: 30,
    category: "AI Features",
    question: "What is the AI Summary?",
    answer:
      "In busy groups, the AI can generate a \"Daily Digest\" or a summary of missed messages and topics, helping you catch up quickly without reading hundreds of messages.",
  },
  {
    id: 31,
    category: "AI Features",
    question: "How do I use AI Discussion Prompts?",
    answer:
      "If a conversation is stalling, the group AI can provide discussion prompts to help kickstart the chat. This can be enabled or disabled in Group AI Settings.",
  },
  {
    id: 32,
    category: "Account & Settings",
    question: "Can I change my phone number?",
    answer:
      "Yes. Go to Settings > Profile and select \"Change Phone Number.\" You will need to verify the new number to complete the process.",
  },
  {
    id: 33,
    category: "Account & Settings",
    question: "How do I manage my storage?",
    answer:
      "SoloChat includes a \"Manage Storage\" tool in Settings that helps you see how much space media files are taking up and allows you to clear cache or delete old files easily.",
  },
  {
    id: 34,
    category: "Account & Settings",
    question: "How do I delete my account?",
    answer:
      "If you wish to leave us, you can find the \"Delete Account\" option in Settings. Please note that this action is permanent and cannot be undone.",
  },
];

export default faq;
